import { createAction } from 'typesafe-actions';

import { EBuildingClassType } from 'shared/types/filters/buildingClassType';

export const changeBuildingClassTypesAction = createAction(
  'filters/builingClassTypesChanged',
  (event: React.ChangeEvent<HTMLInputElement>) => Number(event.target.value),
)<EBuildingClassType>();
